import axios from 'axios';
import envConfig from '../../config/env';

 const ipCheck =  (x) =>{ 

    async function axiosGet() {      
      const postRes = await axios.get(`${envConfig.WebAPI}/GetIP`);
      //console.log(postRes);
      return await postRes.data;

  }
  
  return axiosGet();
 }
export default ipCheck;

